module.exports = __webpack_public_path__ + "img/confirmation.ee35b363.png";